import React, {Component, Fragment} from 'react'
import {message, Modal, Form, DatePicker, Tooltip} from 'antd'
import {getGnOrderNodes, reqGnRecordUpdate, reqGnRecordDel,} from '../../api';
import {subTimeStr, subStr} from "../../utills/subStringUtill";
import {DEMESTIC_ORDER_STATUS} from "../../utills/constants";
import './gn-delivery-step.less'
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');
const confirm = Modal.confirm;
const formItemLayout = {
    labelCol: {
        span: 8,
    },
    wrapperCol: {
        span: 14,
    },
};

class GnDeliveryStep extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: [],
            processShow: false,
            visible: false,
            okBtn: false,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {orderId, orderStatus} = this.props;
        if ((orderId && prevProps.orderId != orderId) || (orderStatus && prevProps.orderStatus != orderStatus)) {
            this.getOptRecord(this.props.orderId);
        }
    }

    saveOptAction = async (action, steps, type, values) => {
        await this.setState({okBtn: true});
        if (action == 'update') {
            const result = await reqGnRecordUpdate(values);
            if (result.code === 200) {
                this.setState({[type]: values.optDt});
                this.setDivs(steps, type, values.optDt);
                //状态改变，刷新页面
                this.props.getOrder(this.props.orderId)
                this.handleCancel();
            } else {
                message.error(result.message);
            }
        }
    };

    delOptAction = async (steps, type, values) => {
        delete values.optDt;
        const result = await reqGnRecordDel(values);
        if (result.code === 200) {
            this.setState({[type]: values.optDt});
            this.setDivs(steps, type, values.optDt);
            //状态改变，刷新页面
            this.props.getOrder(this.props.orderId)
            this.handleCancel();
        } else {
            message.error(result.message);
        }
    };

    getOptRecord = async (orderId) => {
        const result = await getGnOrderNodes(orderId);
        if (result.code === 200) {
            const data = {};
            const statusList = {};
            for (let d of result.data) {
                data[d.optType] = d.optDt;
                statusList[d.seqNo] = d.toStatus;
            }
            this.setDivs(result.data);
            this.setState(data);
            this.setState({statuses: statusList});
        }
    };
    setDivs = (steps, optType, optDt) => {
        if (optType) {
            //时间新增 修改 删除时改变state值
            for (let s of steps) {
                if (s.optType === optType) {
                    Object.assign(s, {optType, optDt});
                    break;
                }
            }
        }
        const {action,} = this.props;
        const divs = (steps || []).map(d => {
                const step = <Fragment>
                    <div className="circle"><i></i></div>
                    <div className="title">{d.optName}</div>
                    <div className="timebox">
                        <div className="time1">{d.optDt ? subStr(d.optDt) : ''}</div>
                        <div className="time2">{d.optDt ? subTimeStr(d.optDt) : ''}</div>
                    </div>
                </Fragment>;
                let className = 'info';
                if (action === 'edit' && d.optType != 'commit' && d.optDt) {
                    className = 'info itemHover';
                }
                if (className === 'info') {
                    return <div className={d.optDt ? 'proceIteam2 finish' : 'proceIteam2'}>
                        <Tooltip title="不可编辑">
                            <div className={className}>{step}</div>
                        </Tooltip>
                    </div>
                }
                return <div className={d.optDt ? 'proceIteam2 finish' : 'proceIteam2'}>
                    <div className={className}
                         onClick={() => this.editDate(d.optType, d.optDt, className === 'info itemHover')}>
                        {step}
                    </div>
                </div>
            }
        );
        this.setState({divs, steps})
    };
    editDate = (type, optDt, editable) => {
        if (editable) {
            if (optDt) {
                this.props.form.setFieldsValue({optDt: moment(optDt, 'YYYY-MM-DD HH:mm:ss')});
            }
            const {steps} = this.state;
            let title;
            for (let s of steps) {
                if (s.optType === type) {
                    title = s.optName;
                    break;
                }
            }
            this.setState({
                visible: true,
                type: type,
                action: 'update',
                title: title
            });
        }
    };

    handleOk = async (e) => {
        const {type, action, steps, statuses} = this.state;
        const data = this.props.form.getFieldsValue();
        const values = {};
        values.orderId = this.props.orderId;
        values.optType = type;
        values.optDt = moment(data.optDt).format('YYYY-MM-DD HH:mm:ss');
        if (data.optDt) {
            this.saveOptAction(action, steps, type, values);
        } else {
            await this.setState({okBtn: true});
            if (action == 'update') {
                let seqNo = 1;
                for (let s of steps) {
                    if (s.optType === type) {
                        seqNo = s.seqNo;
                        break;
                    }
                }
                let preStatus = DEMESTIC_ORDER_STATUS[statuses[seqNo - 1]];
                confirm({
                    title: '删除确认?',
                    content: '删除该时间将会使订单状态变为' + preStatus + '，是否确认删除',
                    onOk: () => {
                        this.delOptAction(steps, type, values);
                    }
                });
            }
        }
    };

    handleCancel = e => {
        this.props.form.resetFields();
        this.setState({visible: false, okBtn: false,});
    };

    render() {
        const {getFieldDecorator,} = this.props.form;
        const {processShow, divs, visible,} = this.state;
        const className = '';
        return (
            <div>
                <div className={processShow ? "processBox2 processShow" + className : 'processBox2' + className}>
                    <Modal
                        title={this.state.title}
                        visible={visible}
                        onOk={this.handleOk}
                        okButtonProps={{disabled: this.state.okBtn}}
                        onCancel={this.handleCancel}>
                        <Form {...formItemLayout}>
                            <Form.Item label="时间">
                                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
                            </Form.Item>
                        </Form>
                    </Modal>
                    {divs}
                </div>
            </div>
        )
    }
}

const GnDeliveryStepForm = Form.create()(GnDeliveryStep);
export default GnDeliveryStepForm;